// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 119) return "static/chunks/119-f0162c845ade2c8e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"211":"8d4cda0b1d291ef3","348":"db6f3cdc453c8bab","589":"e2f2379c71c70876","987":"bf04be4e82f3b6cd"}[chunkId] + ".js";
};